module.exports = __webpack_public_path__ + "img/xwallet.b8fd0c01.svg";